/**
 * QuestionNavigator - Right sidebar component showing question numbers with attempted status
 */
import React from 'react';
import styles from './StudentSubmissionV2.module.css';

const QuestionNavigator = ({ questions, onQuestionClick }) => {
  // Check if a question has been attempted
  const isAttempted = (question) => {
    const response = question?.questionresponse_set;
    if (!response) return false;

    // File upload questions
    if (question.question_type === 'U') {
      return !!(response.response_file || response.response_text);
    }

    // Choice questions (S, SC, ST, M)
    if (response.response_options_ids && response.response_options_ids.length > 0) {
      return true;
    }

    // Text-based questions (D, PA, F, FB, N)
    if (response.response_text && response.response_text.trim() !== '') {
      return true;
    }

    return false;
  };

  return (
    <div className={styles.navigatorPanel}>
      <h6 className={styles.panelTitle}>Questions</h6>

      {/* Legend */}
      <div className={styles.legendRow}>
        <div className={styles.legendItem}>
          <span className={`${styles.legendDot} ${styles.attempted}`}></span>
          <span>Attempted</span>
        </div>
        <div className={styles.legendItem}>
          <span className={`${styles.legendDot} ${styles.notAttempted}`}></span>
          <span>Not Attempted</span>
        </div>
      </div>

      {/* Question Numbers Grid */}
      <div className={styles.questionsGrid}>
        {questions.map((question, index) => {
          const attempted = isAttempted(question);
          return (
            <div
              key={question.id || index}
              className={`${styles.questionNumber} ${attempted ? styles.attempted : styles.notAttempted}`}
              onClick={() => onQuestionClick(index)}
              title={`Question ${index + 1}${attempted ? ' (Attempted)' : ' (Not Attempted)'}`}
            >
              {index + 1}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionNavigator;
